import { render, staticRenderFns } from "./DeleteBusinessAddresses.vue?vue&type=template&id=3496a67d&"
import script from "./DeleteBusinessAddresses.vue?vue&type=script&lang=js&"
export * from "./DeleteBusinessAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports